:host {
  display: block;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--color-off-white);
}

.image {
  width: 100%;
}

.content {
  flex-grow: 1;
  padding: var(--s0) var(--s-1);
}

.heading {
  color: var(--color-cwru-blue);
  font-size: var(--s1);
  margin-top: 0;
  margin-bottom: var(--s-1);
  line-height: 1.2em;
}
